import React, { FunctionComponent } from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import { convertHtmlToText } from '../../utils/utils';

interface Props {
  id: string;
  label: any;
  color?: string;
  disabled?: boolean;
  multiLine?: boolean;
  width?: string;
  size?: any;
  value?: any;
  error?: boolean;
  helperText?: string;
  onChange?: (e: any) => void;
}

const CssTextField = styled(TextField)({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#000000',
  },
  '& .MuiFormLabel-root.Mui-disabled': {
    color: 'grey',
  },
});

export const MyTextFiledLection: FunctionComponent<Props> = ({
  id,
  label,
  color,
  multiLine,
  disabled,
  width,
  size,
  value,
  error,
  helperText,
  onChange,
}) => (
  <CssTextField
    id={id}
    label={label}
    value={convertHtmlToText(value)}
    variant="filled"
    type="text"
    inputProps={{
      style: {
        fontSize: '14px',
        textAlign: 'left',
        fontFamily: 'sans-serif',
        lineHeight: '22px',
      },
    }} // font size of input text
    onChange={onChange}
    error={(error && value === '') || helperText !== ''}
    multiline={multiLine}
    disabled={disabled}
    style={{
      width,
      background: color,
    }}
    helperText={error && value === '' ? 'Введите значение' : helperText}
    size={size}
  />
);

MyTextFiledLection.defaultProps = {
  value: '',
  color: undefined,
  disabled: false,
  multiLine: false,
  width: '100%',
  size: 'large',
  error: false,
  helperText: '',
  onChange: undefined,
};
